// The Vue build version to load with the `import` command
// (runtirouterme-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import "babel-polyfill"
import 'amfe-flexible'
import VueCanvasPoster from 'vue-canvas-poster'



Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.use(VueCanvasPoster)








// 配置自动获取路由标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})




window.sessionStorage.setItem('firstEntryUrl', window.location.href)





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),

})






// WEBPACK FOOTER //
// ./src/main.js